import { ComponentProps } from 'react';
import { Button, Spinner } from 'src/components/atoms';

type ButtonProps = ComponentProps<typeof Button> & {
  loading?: boolean;
};

export const SpinnerButton = ({
  variant = 'primary',
  size = 'medium',
  type = 'button',
  loading = false,
  children,
  ...props
}: ButtonProps) => (
  <Button
    variant={variant}
    size={size}
    data-testid={props['data-testid']}
    type={type}
    loading={loading}
    {...props}
  >
    {loading ? (
      <Spinner
        size={size}
        variant={variant}
        data-testid={props['data-testid'] + '-spinner'}
      />
    ) : (
      children
    )}
  </Button>
);
